import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-podcast-tag',
  templateUrl: './podcast-tag.component.html',
  styleUrls: ['./podcast-tag.component.scss']
})
export class PodcastTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
